import script from "./UserPickerIgnis.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPickerIgnis.vue?vue&type=script&setup=true&lang=js"

import "./UserPickerIgnis.vue?vue&type=style&index=0&id=8c08b62e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c08b62e"]])

export default __exports__